import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getGastroPath(tenant: Tenant): string {
	const pathMap: LocalizedString = {
		[Locale.cs]: "/odvetvi/gastro",
		[Locale.en]: "/industries/gastronomy",
	};

	return getPathInLocale(tenant.locale, pathMap);
}
